import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Typography } from '../../typography/typography';
import styles from './definition-wrapper.module.scss';

type Props = {
  term: string;
  children: ReactNode;
};

export const DefinitionWrapper: React.FC<Props> = ({ term, children }) => {
  return (
    <>
      <dt className={classNames(styles.definitionTerm)} role="term">
        <Typography color="black" fontStyle="bold" variant="smalltext">
          {term}
        </Typography>
      </dt>
      <dd className={styles.definitionDescription}>{children}</dd>
    </>
  );
};
